module.exports = __webpack_public_path__ + "img/male.789244fb.svg";